__turbopack_context__.v({
  "countdownblock--small": "CountdownBlock-module-sass-module__5CCODa__countdownblock--small",
  "countdownblock__buttoncontainer": "CountdownBlock-module-sass-module__5CCODa__countdownblock__buttoncontainer",
  "countdownblock__timercontainer": "CountdownBlock-module-sass-module__5CCODa__countdownblock__timercontainer",
  "countdownblock__timercontainer__illustration": "CountdownBlock-module-sass-module__5CCODa__countdownblock__timercontainer__illustration",
  "countdownblock__timercontainer__timer": "CountdownBlock-module-sass-module__5CCODa__countdownblock__timercontainer__timer",
  "countdownblock__timercontainer__timer--moretext": "CountdownBlock-module-sass-module__5CCODa__countdownblock__timercontainer__timer--moretext",
});
